const ROLES_TABLE_READY = "roles-table-ready"
const SEARCH_TEXT_STATE = "roles-table-search-text-state"
const ROWS_PER_PAGE_STATE = "roles-table-rows-per-page-state"
const PAGINATION_STATE = "roles-table-pagination-state"

const ROLES_ID_FOR_ACTION = "roles-table-brand-id-for-action"


const ADDEDIT_ROLES_READY = "roles-table-addedit-roles-ready"

const initialState = {
    isRolesTableReady: true,
    isAddEditRolesReady: true,
    roles: {},

    
    rolesSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ROLES_TABLE_READY:
            return Object.assign({}, state, { isRolesTableReady: action.payload })

        case ADDEDIT_ROLES_READY:
            return Object.assign({}, state, { isAddEditRolesReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case ROLES_ID_FOR_ACTION:
            return Object.assign({}, state, {rolesSelectedId:action.payload})

        default:
        return state
    
    }

}

export function rolesTableReady(data) {
    return {
        type: ROLES_TABLE_READY,
        payload: data
    }
}

export function addEditRolesReady(data) {
    return {
        type: ADDEDIT_ROLES_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function rolesIdForAction(rolesId){
    return{
        type:ROLES_ID_FOR_ACTION,
        payload:rolesId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Roles/redux/roles.js